const AUTOMATION_SOURCE = {
	TEMPLATES: "automation_templates",
	SCRATCH: "automation_scratch",
	SAVED_AUTOMATIONS: "automation_savedAutomations",
};
const AUTOMATION_TYPE = "automation";
const AUTOMATION_CREATION_STEPS = {
	NAME: "name",
	LIST_SELECTION: "listSelection",
	MARKETING_GOAL: "marketingGoal",
	LIST_SELECTION_AB_SPLITS: "listSelectionForABSplits",
	SELECT_AUTOMATION_TYPE: "automationType"
};
const EVENT_TYPES = {
	TRIGGER_SUBSCRIBED: "TRIGGER_SUBSCRIBED",
	TRIGGER_HELPERTRIGGER: "TRIGGER_HELPERTRIGGER",
	TRIGGER_STRIPE_CHARGE_SUCCEEDED: "TRIGGER_STRIPE.CHARGESUCCEEDED",
	TRIGGER_STRIPE_SUBSCRIPTION_CREATED: "TRIGGER_STRIPE.CUSTOMERSUBSCRIPTIONCREATED",
	TRIGGER_STRIPE_SUBSCRIPTION_DELETED: "TRIGGER_STRIPE.CUSTOMERSUBSCRIPTIONDELETED",
	TRIGGER_STRIPE_SUBSCRIPTION_UPDATED: "TRIGGER_STRIPE.CUSTOMERSUBSCRIPTIONUPDATED",
	TRIGGER_STRIPE_CUSTOMER_CREATED: "TRIGGER_STRIPE_CUSTOMER_CREATED",
	TRIGGER_STRIPE_PAYMENT_FAILED: "TRIGGER_STRIPE.INVOICEPAYMENTFAILED",
	TRIGGER_STRIPE_PAYMENT_SUCCEEDED: "TRIGGER_STRIPE.INVOICEPAYMENTSUCCEEDED",
	TRIGGER_STRIPE_INVOICE_UPCOMING: "TRIGGER_STRIPE.INVOICEUPCOMING",
	TRIGGER_STRIPE_INVOICE_OVERDUE: "TRIGGER_STRIPE.INVOICEOVERDUE",
	TRIGGER_ONSCHEDULE: "TRIGGER_ONSCHEDULE",
	// TRIGGER_CONTACTUNTAGGED: "TRIGGER_CONTACTUNTAGGED",
	TRIGGER_CONTACTTAGGED: "TRIGGER_CONTACTTAGGED",
	CONDITION_DELAY: "CONDITION_DELAY",
	ACTION_EMAILAPI: "ACTION_EMAILAPI",
	ACTION_SENDEMAIL: "ACTION_SENDEMAIL",
	ACTION_RSSSTORE: "ACTION_RSSSTORE",
	CONDITION_RSSCHECK: "CONDITION_RSSCHECK",
	CONDITION_IFELSE: "CONDITION_IFELSE",
	CONDITION_SPLIT50: "CONDITION_SPLIT50",
	CONDITION_ABTEST: "CONDITION_ABTEST",
	CONDITION_FILTERSET: "CONDITION_FILTERSET",
	ACTION_UPDATECONTACT: "ACTION_UPDATECONTACT",
	ACTION_ADDCONTACT: "ACTION_ADDCONTACT",
	ACTION_DELETECONTACT: "ACTION_DELETECONTACT",
	ACTION_LOOP: "ACTION_LOOP",
	CONDITION_SEGMENTSELECTION: "CONDITION_SEGMENTSELECTION",
	ACTION_UPDATECONTACTTAGS: "ACTION_UPDATECONTACTTAGS",
};
const EVENTS = {
	ACTION: "action",
	TRIGGER: "trigger",
	CONDITION: "condition",
};

const EDITOR_MODE = {
	WORKFLOW: "WORKFLOW",
	VALIDATION: "VALIDATION",
	MANAGE_CONTACTS: "MANAGE_CONTACTS",
	NUMBERING: "NUMBERING",
	DISABLED: "DISABLED",
};

const STRIPE_TRIGGERS = ["Stripe.ChargeSucceeded", "Stripe.CustomerSubscriptionCreated", "Stripe.CustomerSubscriptionDeleted",
	"Stripe.InvoicePaymentFailed", "Stripe.InvoicePaymentSucceeded", "Stripe.InvoiceUpcoming",
	"Stripe.CustomerSubscriptionUpdated", "Stripe.InvoiceOverdue"];
export {
	AUTOMATION_SOURCE,
	AUTOMATION_TYPE,
	AUTOMATION_CREATION_STEPS,
	EVENT_TYPES,
	EVENTS,
	EDITOR_MODE,
	STRIPE_TRIGGERS,
};
